import React, {Component} from 'react';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import { Iterable } from 'immutable';

import { completePasswordReset } from 'User';
import Input from 'eksenia-lib/src/Input';
import Button from 'eksenia-lib/src/Button';
import { INPUT_FORMATTERS } from 'eksenia-lib/src/formatters';

class ResetPassword extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            pwd: '',
            resetFailed: false,
            redirectToDashboard: false,
            submitDisabled: false,
            pwdEmptyError: false,
        };

        this.handlePwdChange = this.handlePwdChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.completePasswordResetInProgress && !this.props.completePasswordResetInProgress) {
            this.setState({
                resetFailed: !this.props.completePasswordResetSuccess,
                submitDisabled: this.props.completePasswordResetSuccess,
                redirectToDashboard: this.props.completePasswordResetSuccess,
            });
        }
    }

    handleSubmit(evt) {
        evt.preventDefault();
        if (this.state.pwd.length === 0) {
            this.setState({
                pwdEmptyError: true,
            });
        } else {
            this.setState({
                submitDisabled: true,
                pwd: '',
            });
            this.props.completePasswordReset(this.props.match.params.token, this.state.pwd);
        }
    }

    handlePwdChange(value) {
        this.setState({
            pwd: value,
            pwdEmptyError: false,
            resetFailed: false,
        });
    }

    render() {
        const {
            user,
        } = this.props;
        const {
            pwd,
            submitDisabled,
            pwdEmptyError,
            resetFailed,
        } = this.state;

        if (Iterable.isIterable(user) && user.toJS().Email) {
            return (
                <Redirect to="/" />
            );
        }

        return (
            <div className="reset-password">
                <form onSubmit={this.handleSubmit}>
                      <Input
                        type="password"
                        value={pwd}
                        onChange={this.handlePwdChange}
                        label="Password"
                        formatters={[INPUT_FORMATTERS.VERTICAL]}
                    />

                    <Button
                        type="submit"
                        disabled={submitDisabled}
                    >
                        Submit
                    </Button>
                </form>
                {
                    pwdEmptyError
                        ? <div>Password cannot be empty</div>
                        : undefined
                }
                {
                    // TODO wrong credential vs internal error
                    resetFailed
                        ? <div>Reset failed</div>
                        : undefined
                }
            </div>
        )
    }
}

const mapStateToProps = store => {
    const userReducer = store.userReducer;
    return {
        completePasswordResetInProgress: userReducer.get('completePasswordResetInProgress'),
        completePasswordResetSuccess: userReducer.get('completePasswordResetSuccess'),
        user: userReducer.get('user'),
    }
};
const mapDispatchToProps = { completePasswordReset };

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
